import { CraveErrorCode } from '@/enums/errorCodes';

// Lets non-React code (e.g. the token-refresh service) trigger the app-level
// error overlay. AuthProvider listens for this event and renders the overlay.
export const FATAL_ERROR_EVENT = 'crave:fatal-error';

export type FatalErrorEventDetail = {
  code: CraveErrorCode;
};

export const dispatchFatalError = (code: CraveErrorCode) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<FatalErrorEventDetail>(FATAL_ERROR_EVENT, { detail: { code } })
  );
};
